import { render, staticRenderFns } from "./FlightDetailModal.vue?vue&type=template&id=45cfb729&scoped=true&"
import script from "./FlightDetailModal.vue?vue&type=script&lang=ts&"
export * from "./FlightDetailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cfb729",
  null
  
)

export default component.exports